<template>
	<div id="content" class="content login">

		<div class="container">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit">로그인</h2>
			</div>
			<form @submit.prevent="doLogin">
				<div class="login-form">
					<div class="inp-box">

						<input class="inp-id" type="text" id="deviceToken" v-show="LOCAL === 'localhost'" placeholder="장치 토큰" readonly="readonly">

						<input class="inp-id" type="email" placeholder="아이디" v-model="userid" required>
						<input class="inp-pw" type="password" placeholder="비밀번호" v-model="passwd" required>
						<div class="checkbox" v-show="!isSSOMode">
							<input class="inp-check" type="checkbox" name="stay" id="stay-login" :true-value="true" :false-value="false" v-model="isKeepSession">
							<label class="lab-check" for="stay-login">로그인 상태 유지</label>
						</div>
						<button type="submit" class="btn-login">이메일로 로그인</button>
					</div>
				</div>
				<div class="link-area">
					<a href="/member/joinForm" class="link-join">이메일로 회원가입</a>
					<a href="/member/findId" class="link-findid">아이디 찾기</a>
					<a href="/member/findPasswd" class="link-findpw">비밀번호 찾기</a>
				</div>
				<div class="sns-account m-t-40" v-show="isShowSnsLogin || subDomain === 'www'" :style="subDomain !== 'www' ? 'display: none;' : 'display: '" >
					<!-- NAVER LOGIN ON IOS/MAC -->
					<template v-if="isIOS">
						<a href="javascript:" class="btn-naver" @click="naverLoginOnIOS">네이버로 로그인<a class="hide-login-image"></a></a>
						<a class="hide-login-image" id="naver_id_login" style="display: none"></a>
					</template>

					<!-- NAVER LOGIN ON ANDROID/WINDOW -->
					<template v-else>
						<a href="javascript:" class="btn-naver" @click="naverLogin">네이버로 로그인<a class="hide-login-image" id="naver_id_login"></a></a>
					</template>

					<!-- KAKAO LOGIN -->
					<a href="javascript:" class="btn-kakao" @click="kakaoLogin">카카오로 로그인</a>

					<!-- APPLE LOGIN -->
					<a href="javascript:" class="btn-apple" @click="doAppleLogin">애플로 로그인<a class="hide-login-image" id="appleid-signin" style="width: 1px;" data-border="true" data-type="sign in"></a></a>
					<!--<a href="javascript:;" class="btn-google">구글로 로그인</a>-->
				</div>
			</form>
		</div>
	</div>

</template>


<!--<script type="application/javascript" src="https://developers.kakao.com/sdk/js/kakao.js"></script>-->
<!--<script type="application/javascript" src="https://static.nid.naver.com/js/naverLogin_implicit-1.0.3.js" charset="utf-8"></script>-->
<script>

// import Kakao from "https://developers.kakao.com/sdk/js/kakao.js"

// import("https://developers.kakao.com/sdk/js/kakao.js")
// import("https://static.nid.naver.com/js/naverLogin_implicit-1.0.3.js")

import webUtils from "@/commons/utils/web.utils";

let deviceToken = "";

export default {
	name: "login",
	data() {

		return {

			LOCAL: location.hostname,

			userid: "",
			passwd: "",
			deviceToken: "",
			isKeepSession: false,
			isIOS: false,
			callBackIOSDataApple: "",
			subDomain: "",
			naverCallVal: "",
			/** 네이버 SDK init_naver_id_login 완료 후에만 true (앵커 없이 클릭하면 팝업 차단·무응답 방지) */
			naverOAuthReady: false,

			isShowShopping: true,
			isShowSnsLogin: true,
			
			// SSO 로그인 관련
			isSSOMode: false,
			ssoParams: {
				uuid: null,
				gid: null,
				redirecturl: null
			}
		}
	},
	created() {
		// loginPopup 라우트로 들어올 때 세션 제거 (SSO 로그인을 위해)
		if (this.$route.name === 'loginPopup' || (this.$route.query.uuid && this.$route.query.gid && this.$route.query.redirecturl)) {
			this.$session.destroy();
		}

		this.$loadScript("https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js").then(() => {

			window.AppleID.auth.init({
				clientId: "com.ssflex.app.web",
				scope: "name email",
				redirectURI: this.APIs.APPLE_LOGIN_RETURN,
				state: "origin:web",
				usePopup: true,
			});

			document.addEventListener('AppleIDSignInOnSuccess', (data) => {
				//console.log(data)
				this.callBackAppleLogin(data)
			});

			document.addEventListener('AppleIDSignInOnFailure', (e) => {
				if (webUtils.getParameter("subDomain") !== "" && webUtils.getSubdomainWithURLString(location.origin) !== "www") {
						location.href = location.href.replace(webUtils.getSubdomainWithURLString(location.origin), webUtils.getParameter("subDomain")).replace(/[&;]?subDomain=[^&;]+/, "")
				}
			});

			if (webUtils.getParameter("subDomain") !== "") {
				document.querySelectorAll('body').forEach(e => e.style.display = 'none')
				document.querySelector('#appleid-signin').click()
			}

		})

		// get connected iOS or MacOS
		if (((navigator.userAgent).indexOf("iPad")) !== -1 || ((navigator.userAgent).indexOf("iPhone")) !== -1 || ((navigator.userAgent).indexOf("iPod")) !== -1 || ((navigator.userAgent).indexOf("Mac")) !== -1) {
			this.isIOS = true;
		}

		// get connected App
		// this.isApp = /inApp/i.test(window.navigator.userAgent)

		this.subDomain = webUtils.getSubdomain();

		// SSO 파라미터 확인
		if (this.$route.query.uuid && this.$route.query.gid && this.$route.query.redirecturl) {
			this.isSSOMode = true;
			this.ssoParams = {
				uuid: this.$route.query.uuid,
				gid: this.$route.query.gid,
				redirecturl: decodeURIComponent(this.$route.query.redirecturl)
			};
			
			// 팝업으로 열렸는지 확인 (SSO 모드일 때 팝업 스타일 적용 가능)
			if (window.opener && !window.opener.closed) {
				// 팝업 모드로 열렸을 때 추가 처리 (필요시)
				document.body.classList.add('sso-popup-mode');
			}
		}

		// loginPopup이 아닐 때만 기존 로그인 체크
		if (this.$route.name !== 'loginPopup' && this.isLogin()) {
			this.swalUtils.fire("현재 로그인 되어 있습니다.", "메인으로 이동합니다.", "info")
				.then(() => {
					location.href = "/"
				})
		}
	},
	mounted() {
		// loginPopup 라우트로 들어올 때 세션 제거 (SSO 로그인을 위해 - 이중 체크)
		if (this.$route.name === 'loginPopup' || (this.$route.query.uuid && this.$route.query.gid && this.$route.query.redirecturl)) {
			this.$session.destroy();
		}

		this.$loadScript("https://developers.kakao.com/sdk/js/kakao.js")
			.then(() => {
				this.kakaoInit();
			})

		this.$loadScript("https://static.nid.naver.com/js/naverLogin_implicit-1.0.3.js")
			.then(() => {
				this.naverInit();
			})


		this.appDeviceToken("#deviceToken")
		// this.getAndroidDeviceToken();
		// this.getIOSDeviceToken();

		this.getCompanyInfo();

		// 네이버 SNS 팝업(naverReturn)이 부모와 다른 창에서 doSSOSnsLogin 후 postMessage만 보내는 경우 대비
		if (this.isSSOMode) {
			this._ssoPopupMessageHandler = (ev) => {
				const d = ev.data;
				if (!d || typeof d !== "object") return;
				if (!this._isTrustedSsoChildOrigin(ev.origin)) return;
				if (d.key === "sso_login_success" && d.redirectUrl) {
					location.href = d.redirectUrl;
					return;
				}
				if (d.key === "sso_login_fail") {
					this.swalUtils.fireSsoLicenseAuthGuide(d.msg);
				}
			};
			window.addEventListener("message", this._ssoPopupMessageHandler);
		}
	},
	beforeDestroy() {
		if (this._ssoPopupMessageHandler) {
			window.removeEventListener("message", this._ssoPopupMessageHandler);
			this._ssoPopupMessageHandler = null;
		}
	},
	watch: {},
	updated() {
	},
	methods: {

		/** OAuth 리다이렉트 팝업(동일 앱, localhost↔127.0.0.1 등)에서 온 postMessage만 허용 */
		_isTrustedSsoChildOrigin(origin) {
			if (origin === location.origin) return true;
			try {
				const a = new URL(origin);
				const b = new URL(location.origin);
				if (a.protocol !== b.protocol) return false;
				if ((a.port || "") !== (b.port || "")) return false;
				const loopback = (h) => h === "localhost" || h === "127.0.0.1";
				return loopback(a.hostname) && loopback(b.hostname);
			} catch (e) {
				return false;
			}
		},

		doLogin(e) {

			e.preventDefault()

			// SSO 모드면 SSO 로그인 처리
			if (this.isSSOMode) {
				this.doSSOLogin();
			} else {
				this.doLoginProc(this.userid, this.passwd, () => {

					this.setSessionKeep(this.isKeepSession);
					
					// referrer가 있으면 그곳으로 이동, 없으면 goWithCoCode 호출
					if (!this.stringUtils.isEmpty(this.$route.query.referrer)) {
						let referrer = decodeURIComponent(this.$route.query.referrer);
						// referrer가 경로만 있으면 전체 URL로 변환
						if (referrer.startsWith('/')) {
							referrer = location.origin + referrer;
						}
						location.href = referrer;
					} else {
						this.goWithCoCode(this);
					}

				});
			}

		},

		doSSOLogin() {
			const self = this;
			
			this.$session.destroy();
			this.$eventBus.$emit("startProgress", 2);
			
			this.axiosCaller.post(this, this.APIs.SESSION + "/doSSOLogin", {
				userid: this.userid,
				passwd: this.passwd,
				deviceToken: (this.webUtils.isDom('#deviceToken')) ? document.querySelector('#deviceToken').value : "",
				uuid: this.ssoParams.uuid,
				gid: this.ssoParams.gid,
				redirecturl: this.ssoParams.redirecturl
			}, (res) => {
				this.$eventBus.$emit("doneProgress", 2);
				let result = res.data;

				if (result.status === "ok") {
					// SSO 로그인 성공 시 팝업 창에서 바로 리디렉션
					if (result.redirectUrl) {
						location.href = result.redirectUrl;
					} else {
						self.swalUtils.gritter("로그인 오류", "리디렉션 URL을 받지 못했습니다.", "error", 3000);
					}
				} else {
					const notifyOpener = window.opener && !window.opener.closed;
					if (notifyOpener) {
						window.opener.postMessage({
							key: "sso_login_fail",
							msg: result.msg || "로그인에 실패했습니다."
						}, location.origin);
					} else {
						self.swalUtils.fireSsoLicenseAuthGuide(result.msg);
					}
				}
			});
		},

		/**
		 * SNS 로그인 성공 후 SSO 처리
		 * @param {Object} coAccountVO - 로그인된 계정 정보
		 */
		doSSOSnsLogin(coAccountVO) {
			const self = this;
			
			this.$eventBus.$emit("startProgress", 2);
			
			this.axiosCaller.post(this, this.APIs.SESSION + "/doSSOSnsLogin", {
				uuid: this.ssoParams.uuid,
				gid: this.ssoParams.gid,
				redirecturl: this.ssoParams.redirecturl
			}, (res) => {
				this.$eventBus.$emit("doneProgress", 2);
				let result = res.data;

				if (result.status === "ok") {
					// SSO 로그인 성공 시 팝업 창에서 바로 리디렉션
					if (result.redirectUrl) {
						location.href = result.redirectUrl;
					} else {
						self.swalUtils.gritter("로그인 오류", "리디렉션 URL을 받지 못했습니다.", "error", 3000);
					}
				} else {
					// 로그인 실패 시 - doSnsLogin에서 생성된 프론트엔드 세션 제거
					this.$session.destroy();
					
					const notifyOpener = window.opener && !window.opener.closed;
					if (notifyOpener) {
						window.opener.postMessage({
							key: "sso_login_fail",
							msg: result.msg || "로그인 인증에 실패했습니다."
						}, location.origin);
					} else {
						self.swalUtils.fireSsoLicenseAuthGuide(result.msg);
					}
				}
			});
		},


		goReferrer() {
			if (!this.stringUtils.isEmpty(this.$route.query.referrer)) {
				console.log(this.$route.query.referrer)
				location.href = this.$route.query.referrer
			} else {
				location.href = "/"
			}
		},


		async getCompanyInfo() {

			const self = this
			self.coInfoVO = await self.getCoInfoVO()
			// 아이폰이 경우 사이트 설정 따라가게 설정
			if (self.appDevice() === "IOS") {
				self.isShowShopping = self.coInfoVO.isIosShop
				self.isShowSnsLogin = self.coInfoVO.isIosSns
			}

		},


		kakaoInit() {
			const self = this
			window.Kakao.init(this.APIs.KAKAO_LOGIN_KEY);
			const ksksoInitResult = window.Kakao.isInitialized();
			console.log("ksksoInitResult", ksksoInitResult)
			if (!ksksoInitResult) {
				self.swalUtils.fire(ksksoInitResult.name, ksksoInitResult.message, "error")
			}
		},

		kakaoLogin(e) {
			if (this.isIOS === true) {
				this.kakaoLoginOnIOS();
				return;
			}

			const self = this

			// 카카오 로그인 팝업
			if (!window.Kakao.isInitialized()) {
				this.kakaoInit();
			}

			window.Kakao.Auth.login({
				success: function (authObj) {
					console.log(authObj)

					window.Kakao.API.request({
						url: '/v2/user/me',
						success: function (response) {
							console.log(response);

							// 카카오 이메일 추출
							let email = null;
							if (response.kakao_account && response.kakao_account.email) {
								email = response.kakao_account.email;
							}

							// DONE : SNS 정보로 로그인 및 없을 경우 저장 후 가입폼으로
							self.axiosCaller.get(self, self.APIs.SESSION + "/doSnsLogin", {
								snsService: "kakao",
								snsId: response.id,
								email: email,
								deviceToken: (self.webUtils.isDom('#deviceToken')) ? document.querySelector('#deviceToken').value : "",
							}, async (res) => {
								const result = res.data;

								if (result.status === "ok") {
									if (await self.setSessionProc(result.coAccountVO)) {
										self.setSessionKeep(self.isKeepSession);
										
										// SSO 모드면 SSO 처리
										if (self.isSSOMode) {
											self.doSSOSnsLogin(result.coAccountVO);
										} else {
											self.goWithCoCode(self);
											self.logingLastLogin();
										}
									}
								} else {
									self.swalUtils.gritter("Error", result.msg, "info", 1500)
								}
							})

						},
						fail: function (error) {
							console.log(error);
							self.swalUtils.fire(error.error, error.error_description, "error")
						}
					});

				},
				fail: function (error) {
					console.log(JSON.stringify(error))
					self.swalUtils.fire(error.error, error.error_description, "error")
				},
			})
		},


		naverInit() {
			this.naverOAuthReady = false;
			if (this.isIOS === true) {
				this.naverCallVal = new window.naver_id_login(this.APIs.NAVER_LOGIN_KEY, this.APIs.NAVER_IOS_LOGIN_RETURN);
			} else {
				this.naverCallVal = new window.naver_id_login(this.APIs.NAVER_LOGIN_KEY, this.APIs.NAVER_LOGIN_RETURN);
			}
			// var naver_id_login = new window.naver_id_login("qFDEQxXzXziHz8pT4Y69", "https://localhost:8081/member/sns/naverReturn");
			var state = this.naverCallVal.getUniqState();
			this.naverCallVal.setButton("white", 3, 40);
			// 로컬 환경이면 동적으로, 아니면 운영 도메인 사용
			if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
				this.naverCallVal.setDomain(location.origin + "/");
			} else {
				this.naverCallVal.setDomain("https://ssflex.co.kr");
			}
			this.naverCallVal.setState(state);
			// 이미 window.open 으로 연 loginPopup 안에서는 OAuth 를 또 팝업으로 띄우면 중첩 팝업·차단 이슈가 잦음 → 같은 창으로 이동
			if (!(window.opener && !window.opener.closed)) {
				this.naverCallVal.setPopup();
			}
			this.naverCallVal.init_naver_id_login();
			this.naverOAuthReady = !!document.getElementById("naver_id_login_anchor");
		},

		naverLogin() {
			if (!this.naverOAuthReady || !this.naverCallVal) {
				this.swalUtils.gritter("안내", "네이버 로그인 초기화 중입니다. 잠시 후 다시 눌러 주세요.", "info", 2500);
				return;
			}
			// SSO 모드면 SSO 파라미터를 세션 스토리지에 저장 (네이버 로그인 후 naverReturn.vue에서 사용)
			if (this.isSSOMode) {
				sessionStorage.setItem('ssoParams', JSON.stringify(this.ssoParams));
			}
			const anchor = document.getElementById("naver_id_login_anchor");
			const url = anchor && anchor.href;
			if (!url) {
				this.swalUtils.gritter("오류", "네이버 로그인 링크를 찾을 수 없습니다. 새로고침 후 다시 시도해 주세요.", "error", 3000);
				return;
			}
			// jQuery로 숨은 앵커를 클릭하면 '가짜 클릭'으로 간주되어 window.open 이 차단되거나 빈 팝업이 바로 닫히는 경우가 많음.
			// 사용자가 방금 버튼을 누른 직후에 같은 스택에서 open / assign 호출.
			if (this.naverCallVal.popup) {
				const opts = "titlebar=1,resizable=1,scrollbars=yes,width=600,height=550";
				const w = window.open(url, "naverloginpop", opts);
				if (!w || w.closed) {
					this.swalUtils.gritter("팝업 차단", "브라우저에서 팝업을 허용한 뒤 다시 시도해 주세요.", "warning", 3500);
				}
			} else {
				window.location.assign(url);
			}
		},

		// callAppleLogin() {
		// 	this.repeatCheckcallBackIOSDataApple();
		// 	webkit.messageHandlers.callAppleLogin.postMessage("")
		// },
		//
		// repeatCheckcallBackIOSDataApple() {
		// 	setTimeout(() => {
		// 		if (document.getElementById("callBackIOSApple").value !== "") {
		// 			this.callBackAppleLogin(document.getElementById("callBackIOSApple").value)
		// 		} else {
		// 			this.repeatCheckcallBackIOSDataApple();
		// 		}
		// 	}, 100)
		// },
		//


		doAppleLogin() {
			if (webUtils.getSubdomainWithURLString(location.origin) !== 'www') {
				location.href = location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), "www") + location.pathname + (location.search === "" ? "?subDomain=" : location.search + "&subDomain=") + webUtils.getSubdomainWithURLString(location.origin)
			} else {
				document.querySelector('#appleid-signin').click()
			}
			// window.open(location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), "www") + '/member/sns/apple/' + webUtils.getSubdomainWithURLString(location.origin), "apple")
			// $('#appleid-signin').click();
		},

		callBackAppleLogin(_result) {

			// "eyJraWQiOiI4NkQ4OEtmIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwczovL2FwcGxlaWQuYXBwbGUuY29tIiwiYXVkIjoiY29tLnNzZmxleC5hcHAud2ViIiwiZXhwIjoxNjM4MzIxMTIwLCJpYXQiOjE2MzgyMzQ3MjAsInN1YiI6IjAwMDA1Mi42ZjdhODIwODU1MWM0ODU3YmRlZTljNDA2OWMzOWExOS4wMDMzIiwiY19oYXNoIjoiMVBUX3A5Q3BYYWVSQ29jV0RKUkVwQSIsImVtYWlsIjoia2hhbmUwOTA3QGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjoidHJ1ZSIsImF1dGhfdGltZSI6MTYzODIzNDcyMCwibm9uY2Vfc3VwcG9ydGVkIjp0cnVlfQ.euASmIA1XVuXQ4Fxq_z7UjzZ4U7wEW0kMb4ZM4kQKzO9DEI-_0khX1vJuJPYGADhW-emoDr7oIdRPWeKAqBxAsxewZQTHeT1Y9-S48pGF-GYJwbeUWEOD_7QXSp0Qwd8IPu2jOVTnkbehbPSNOsre7FmPPi7_9_a2Ej1Zki-uHXiS6c7wflkIc4MmmTfMxZPazzC-c_UmVZBlux5SztgvLYJ1g3nDaqZ9yuALYkMbSPIxrnC1fiKhMnHOJLtMHPIDIxyZbWG5V23H_YPLuJpkKUSW0rT_hIwNKR_Ev3Ie09eABrWe_gCGZjaOKGDIn-DRbug1pr7yvBIN1iOf6PTdg"
			// Decode From Base64 => {"kid":"eXaunmL","alg":"RS256"}
			// Decode From Base64 => {"iss":"https://appleid.apple.com","aud":"com.ssflex.app.web","exp":1638939181,"iat":1638852781,"sub":"000686.dad1266e58474f8c873a28b504796298.0450","c_hash":"6-xmm8op9oQLokSNiMPxSw","email":"pjy@humanwares.com","email_verified":"true","auth_time":1638852781,"nonce_supported":true}
			const response = JSON.parse(atob((_result.detail.authorization.id_token).split('.')[1]));
			const uid = response.sub;
			let name;
			let email;

			if (_result.detail.user != null) {
				name = _result.detail.user.name.lastName + _result.detail.user.name.firstName;
				email = _result.detail.user.email;
			}

			if (response.email_verified == "true") {
				email = response.email;
			}

			console.log(response)
			console.log(email)
			console.log(name)

			console.log("get IOS Data")
			const self = this
			self.axiosCaller.get(self, self.APIs.SNS_APPLE + "/doSnsLogin", {
				snsService: "apple",
				snsId: uid,
				email: email,
				name: name,
				deviceToken: (self.webUtils.isDom('#deviceToken')) ? document.querySelector('#deviceToken').value : "",
				LOGIN_DOMAIN: webUtils.getParameter("subDomain") !== '' ? webUtils.getParameter("subDomain") : null,
				coCode: webUtils.getParameter("subDomain") !== '' ? webUtils.getParameter("subDomain") : null
			}, async (res) => {
				const result = res.data;
				console.log(result)

				if (result.status === "integrated_login") {
					self.swalUtils.fire("계정 통합", result.msg, "info")
						.then(async swalResult => {
							console.log(swalResult)
								if (swalResult.isConfirmed || swalResult.dismiss) {
								if (await self.setSessionProc(result.coAccountVO)) {
									self.setSessionKeep(self.isKeepSession);
									
									// SSO 모드면 SSO 처리
									if (self.isSSOMode) {
										self.doSSOSnsLogin(result.coAccountVO);
									} else {
										self.goWithCoCode(self);
									}
								}
							}
						});
					return
				}

				if (result.status === "login") {
					if (await self.setSessionProc(result.coAccountVO)) {
						self.setSessionKeep(self.isKeepSession);
						
						// SSO 모드면 SSO 처리
						if (self.isSSOMode) {
							self.doSSOSnsLogin(result.coAccountVO);
						} else {
							self.goWithCoCode(self);
						}
					}
				} else {
					self.swalUtils.gritter("Error", result.msg, "info", 1500, () => {
						if (webUtils.getParameter("subDomain") !== "") {
							location.href = location.href.replace(webUtils.getSubdomainWithURLString(location.origin), webUtils.getParameter("subDomain")).replace(/[&;]?subDomain=[^&;]+/, "")
						}
					})
				}
			})
		},

		kakaoLoginOnIOS() {
			var self = this;
			
			// SSO 모드면 SSO 파라미터를 세션 스토리지에 저장
			if (this.isSSOMode) {
				sessionStorage.setItem('ssoParams', JSON.stringify(this.ssoParams));
			}
			
			const url = 'https://kauth.kakao.com/oauth/authorize?'
				+ 'client_id=' + self.APIs.KAKAO_REST_API_LOGIN_KEY + '&'
				+ 'redirect_uri=' + self.APIs.KAKAO_IOS_LOGIN_RETURN + '&'
				+ 'response_type=' + 'code';

			location.href = url
		},

		naverLoginOnIOS() {
			var self = this;
			
			// SSO 모드면 SSO 파라미터를 세션 스토리지에 저장
			if (this.isSSOMode) {
				sessionStorage.setItem('ssoParams', JSON.stringify(this.ssoParams));
			}
			
			const url = 'https://nid.naver.com/oauth2.0/authorize?'
				+ 'client_id=' + self.naverCallVal.client_id + '&'
				+ 'redirect_uri=' + self.naverCallVal.redirect_uri + '&'
				+ 'response_type=' + 'code' + '&'
				+ 'state=' + self.naverCallVal.state;

			location.href = url
		},
	},
}

</script>

<style scoped>
.hide-login-image {
	position: relative;
	top: -56px;
	opacity: 0;
}

.login .sns-account .btn-apple {
	background-color: #1c1c1e;
	background-image: url(/ssflex/assets/img/common/ico_apple.png);
	color: #fff;
}

</style>
